export default __webpack_public_path__ + "static/media/girl-4181395_960_720.dbc0cd61.jpg";